'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.tpFirmwares.list', [])
  .controller('TpFirmwaresListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/tpFirmwares/list/index.js